import { render } from "./error403.vue?vue&type=template&id=37fecd1c"
import script from "./error403.vue?vue&type=script&lang=js"
export * from "./error403.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__